"use client";

// Фирменный знак KLAIT.
//
// Продукт переименован из Mise в kait (решение Марата 05.08). Знак и начертание
// взяты из production-пака как есть; здесь они инлайнятся, а не грузятся
// картинкой, по двум причинам: цвет должен наследоваться от места
// (`currentColor` — на тёмном рельсе белый, на светлой странице графитовый), и
// знак не должен моргать отдельным запросом на каждой загрузке.
//
// viewBox у обоих ПЛОТНЫЙ — обрезан по краям самой фигуры. В исходных файлах
// вокруг фигуры есть поля, и у знака с логотипом они разные: рендер «как есть»
// разъезжался бы по левому краю и по высоте при переключении между свёрнутым и
// раскрытым рельсом. С плотным кадром обе формы садятся на одну линию сами.
//
// Исходники пака лежат в public/brand (в том числе png с прозрачностью и
// иконки под iOS) — они понадобятся для манифеста и сторов.

export function KaitMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 749 317" className={className} fill="currentColor" role="img" aria-label="kait">
      <path fillRule="evenodd" d="M 562 67 L 568 61 L 739 61 L 746 67 L 747 74 L 744 82 L 650 231 L 644 227 L 627 206 L 641 182 L 642 172 L 639 164 L 563 75 Z M 2 10 L 4 5 L 9 2 L 410 2 L 430 7 L 443 14 L 458 27 L 605 198 L 621 214 L 635 232 L 641 238 L 645 238 L 645 240 L 642 242 L 616 283 L 599 302 L 583 313 L 566 315 L 560 313 L 551 305 L 531 279 L 394 118 L 379 112 L 198 112 L 193 118 L 196 124 L 273 216 L 289 222 L 461 222 L 474 232 L 518 285 L 518 289 L 515 292 L 251 292 L 235 288 L 219 280 L 202 265 L 105 141 L 100 137 L 4 17 Z" />
    </svg>
  );
}

export function KaitWordmark({ className }: { className?: string }) {
  // Текстом, а не вектором (правка Марата 28.08): SVG-словомарка несла старые
  // буквы «KAIT», а перерисовать вектор под KLAIT нечем — текст всегда верен
  // бренду и красится через currentColor, как и вектор.
  return (
    <span
      className={className}
      style={{ fontWeight: 800, letterSpacing: "0.04em", fontSize: "1em", lineHeight: 1 }}
    >
      KLAIT<sup style={{ fontSize: "0.5em", fontWeight: 600 }}>®</sup>
    </span>
  );
}

/**
 * Знак MLT — студии, которая делает продукт.
 *
 * НАСТОЯЩИЙ логотип из `public/brand/mlt-white.png` (Марат положил исходник
 * 07.08). До этого здесь три захода жила перерисовка кодом — она удалена.
 *
 * Как готовился файл: исходник чёрный на белом, без прозрачности. Скриптом на
 * sharp белый фон переведён в альфу, знак перекрашен в белый, пустые поля
 * обрезаны по непрозрачным пикселям (было 1847×851 с воздухом, стало
 * 1587×264 — только сам знак). Белый выбран потому, что живёт он на тёмном
 * экране входа; прозрачность позволяет приглушать его одной opacity, не трогая
 * файл.
 *
 * ⚠️ Файл РАСТРОВЫЙ. Для печати и крупных размеров нужен вектор — если у студии
 * есть `mlt.svg`, положите рядом и поменяйте `src`.
 */
export function MltMark({ className }: { className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/brand/mlt-white.png"
      alt="MLT"
      className={className}
      // Размеры исходника: без них Next ругается на отсутствие пропорций, а
      // браузер на секунду отдаёт под картинку нулевую высоту.
      width={1587}
      height={264}
    />
  );
}
